import { useOpenSearchContext } from './useOpenSearchContext';

const useHits = <T>() => {
  const { hits, totalHits } = useOpenSearchContext();

  const hitsData = hits?.map(({ _source }) => _source as T);

  return {
    hits: hitsData,
    totalHits,
  };
};

export { useHits };
